import { PATH_ROOTS } from '@common/constants';

import { getMetaInfoPath } from '../../Parser/bindings';

export const SQL_ROOT_METAINFO_PATH = getMetaInfoPath(PATH_ROOTS.SQL);
export const SQL_FILESYSTEM_PATH = `${SQL_ROOT_METAINFO_PATH}.fileSystem`;
export const SQL_DATASETS_PATH = `${SQL_ROOT_METAINFO_PATH}.datasets`;
export const SQL_STORED_PROCEDURES_PATH = `${SQL_ROOT_METAINFO_PATH}.storedProcedures`;
export const SQL_PIPELINES_PATH = `${SQL_ROOT_METAINFO_PATH}.pipelines`;
export const SQL_CURRENT_MODAL_GRAPH_PATH = `${PATH_ROOTS.SQL}.currentModelGraph`;
export const SQL_CURRENT_PIPELINE_GRAPH_PATH = `${PATH_ROOTS.SQL}.currentPipelineGraph`;
export const SQL_CURRENT_SNAPSHOT_GRAPH_PATH = `${PATH_ROOTS.SQL}.currentSnapshotGraph`;
export const SQL_CURRENT_SINGULAR_DATA_TEST_GRAPH_PATH = `${PATH_ROOTS.SQL}.currentSingularDataTestGraph`;
export const SQL_CURRENT_MACRO_PATH = `${PATH_ROOTS.SQL}.currentMacro`;
export const SQL_CURRENT_GEM_PATH = `${PATH_ROOTS.SQL}.currentGem`;
export const SQL_CURRENT_GENERIC_DATA_TEST_PATH = `${PATH_ROOTS.SQL}.currentGenericDataTest`;
export const SQL_DEPENDENCY_CONTAINER_PATH = `${SQL_ROOT_METAINFO_PATH}.dependenciesContainer`;
export const SQL_CURRENT_APP_PATH = `${PATH_ROOTS.SQL}.currentApp`;
export const DO_NOT_USE_SQL_HIDDEN_UI_PATH = `${SQL_FILESYSTEM_PATH}.children.hiddenUIPath`;
